import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as paperWalletApi from "../../../api/paperWallet";

export function useAllowedPaperWallets() {
  return useQuery({
    queryKey: ["allowedPaperWallets"],
    queryFn: () => paperWalletApi.fetchAll(),
  });
}

export function useSavePaperWallet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => paperWalletApi.save(null, req),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["allowedPaperWallets"] }),
  });
}
